import { render, staticRenderFns } from "./mainNone.vue?vue&type=template&id=706ce8f2&"
import script from "./mainNone.vue?vue&type=script&lang=js&"
export * from "./mainNone.vue?vue&type=script&lang=js&"
import style0 from "./mainNone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports